// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".css__FW6jd-.css__cI5dlM.css__cI5dlM{--button-text:var(--theme_white);align-items:center;border-radius:50%;display:inline-flex;height:1.5rem;justify-content:center;min-height:1.5rem;min-width:1.5rem;padding:0;width:1.5rem}.css__FW6jd-.css__cI5dlM.css__cI5dlM>span{align-items:center;display:flex;justify-content:center;line-height:1;padding:0}.css__FW6jd-.css__cI5dlM.css__cI5dlM>span>svg{display:block;stroke-width:3}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"close_button": "css__FW6jd-",
	"close": "css__cI5dlM"
};
module.exports = ___CSS_LOADER_EXPORT___;
